import React from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import ProjectNavigation from "../components/ProjectNavigation"
import ResponsiveImage from "../components/ResponsiveImage"

const LeviRespirate = () => {
    // Define images array with all presentation slides in order
    const presentationSlides = Array.from({ length: 21 }, (_, i) => 
        `/images/projects/Levi Respirate/FSF Sam Gaston 2023-${i + 1}`
    )
    
    // Function to create an open in new tab button
    const OpenInNewTabButton = ({ imagePath }) => (
        <a 
            href={imagePath} 
            target="_blank" 
            rel="noopener noreferrer"
            className="open-in-new-tab-btn"
        >
            Open in new tab
        </a>
    )

    // Full-bleed wrapper (lets slides span the full viewport width)
    const fullBleedStyle = {
        width: "100vw",
        marginLeft: "calc(50% - 50vw)",
        marginRight: "calc(50% - 50vw)",
    }

    const fullBleedInnerStyle = {
        paddingLeft: "20px",
        paddingRight: "20px",
        boxSizing: "border-box",
    }

    return (
        <div>
            <Header />
            <ProjectNavigation currentProject="/levi-respirate" />
            
            <div style={{
                textAlign: "center",
                padding: "30px 0 20px",
                marginBottom: "10px"
            }}>
                <h1 style={{ 
                    fontSize: "32px",
                    margin: "0",
                    fontWeight: "bold"
                }}>Fashion Scholarship Fund 2024 Levi Strauss & Co. "Respirate" Winning Case Study</h1>
            </div>

            <main>
                <div style={{ 
                    padding: "20px",
                    maxWidth: "1200px", 
                    margin: "0 auto"
                }}>
                    <div style={{ 
                        display: "flex",
                        flexDirection: "column",
                        gap: "40px",
                        marginBottom: "50px"
                    }}>
                        {presentationSlides.map((image, index) => (
                            <div key={`slide-${index}`}>
                                <div style={fullBleedStyle}>
                                    <div
                                        style={{
                                            ...fullBleedInnerStyle,
                                            display: "flex",
                                            justifyContent: "center",
                                            height: "auto",
                                            margin: "0 auto",
                                            width: "100%",
                                        }}
                                    >
                                        <ResponsiveImage
                                            src={`${image}.webp`}
                                            alt={`Levi Respirate presentation slide ${index + 1}`}
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                objectFit: "contain"
                                            }}
                                            priority={index === 0}
                                            loading={index < 3 ? "eager" : "lazy"}
                                            sizes="100vw"
                                        />
                                    </div>
                                    <div
                                        style={{
                                            ...fullBleedInnerStyle,
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            width: "100%",
                                            margin: "0 auto"
                                        }}
                                    >
                                        <OpenInNewTabButton imagePath={`${image}.webp`} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default LeviRespirate